import axios from "axios";
import storage from "redux-persist/lib/storage";
import { apiPath, API_URL, APP_URL, REACT_APP_X_API_KEY, HOST_TYPE } from "./apiPath";
import { getAccessToken, getLocalTimeZone, showSuccessOrError } from "./commonService";
import { logoutApp } from "../redux/Slices/common/login/LoginSlice";

const login = (email, password, rememberMe) => {
  return axios
    .post(
      APP_URL + apiPath.login,
      {
        email,
        password,
      },
      {
        headers: {
          language: localStorage.getItem('i18nextLng'),
          'Accept-Language': localStorage.getItem('i18nextLng'),
          timezone: getLocalTimeZone(),
          'x-api-key': REACT_APP_X_API_KEY,
          'hosttype': HOST_TYPE,
          'ip': localStorage.getItem('userIP'),
          'device': navigator.userAgent
        },
      }
    )
    .then((response) => {
      if (response.data.token) {
        const userData = response.data;

        if (rememberMe) {
          localStorage.setItem("user", JSON.stringify(userData));
        } else {
          sessionStorage.setItem("user", JSON.stringify(userData));
        }
      }
      return response.data;
    });
};
const forgotPassword = (email) => {
  return axios
    .post(API_URL + apiPath.forgotPassword, {
      email,
    })
    .then((response) => {
      return response.data;
    });
};
const resetPassword = (password, token) => {
  return axios
    .post(API_URL + apiPath.resetPassword, {
      password,
      token,
    })
    .then((response) => {
      return response.data;
    });
};
const logout = () => {
  const { store } = require("../redux/store");
  const token = getAccessToken();
  store.dispatch(logoutApp({ token })).then((res) => {
    showSuccessOrError(res);
    if (!res.error) {
      localStorage.removeItem("user");
      localStorage.clear();
      storage.removeItem("persist:root");
      window.location.href = "/login";
    }
  });
};
const authService = {
  login,
  logout,
  forgotPassword,
  resetPassword,
};
export default authService;
